import { DealPreparation } from './deal-preparation';
import { UnderReview } from './under-review';

type AcademyProps = {
  status?: string;
  opportunityId: string;
  initialVdrLink?: string | null;
  ndaFile?: any;
};

export function AcademyInfo({ status, opportunityId, initialVdrLink, ndaFile }: AcademyProps) {
  if (status === 'draft') {
    return <DealPreparation />;
  }

  if (status === 'pending') {
    return <UnderReview opportunityId={opportunityId} initialVdrLink={initialVdrLink} ndaFile={ndaFile} />;
  }

  return null;
}
